(function () {
  'use strict';

  if (window.__hdtCardEnhancements3Init) return;
  window.__hdtCardEnhancements3Init = true;

  /* ---------- image/video slider core ---------- */
  function setActiveSlide(track, index) {
    var slides = track.querySelectorAll('.hdt-card-slider__slide');
    var parent = track.closest('hdt-product-card-media');
    var segs = parent ? parent.querySelectorAll('.hdt-card-slider__seg') : [];
    if (!slides.length) return;
    index = ((index % slides.length) + slides.length) % slides.length;

    slides.forEach(function (s, i) {
      var wasActive = s.classList.contains('is-active');
      var isActive = i === index;
      s.classList.toggle('is-active', isActive);

      if (s.dataset.mediaType === 'video') {
        var video = s.querySelector('video');
        if (video) {
          if (isActive && !wasActive) {
            video.currentTime = 0;
            video.play().catch(function () { /* autoplay blocked, ignore */ });
          } else if (!isActive && wasActive) {
            video.pause();
          }
        }
      }
    });

    segs.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    track.dataset.activeIndex = index;
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hdt-card-slider__track').forEach(function (track) {
      setActiveSlide(track, 0);
    });
  });

  function getTrack(el) {
    var parent = el.closest('hdt-product-card-media');
    return parent && parent.querySelector('.hdt-card-slider__track');
  }

  var DRAG_EXCLUDE_SELECTOR = '.hdt-size-list--clickable, .hdt-card-slider__nav, .hdt-card-slider__arrow';
  var DRAG_THRESHOLD = 8;

  var dragStart = null;
  var isDragging = false;

  var lastTouchTime = 0;
  var GHOST_EVENT_WINDOW = 600; /* ms */

  /* ---------- navigation-suppression state ----------
     A swipe should slide images WITHOUT navigating; a plain tap should
     navigate normally. Instead of a fragile one-time click listener per
     link, we remember which link was just dragged and check that in a
     single permanent listener below — a timeout guarantees it can never
     get stuck and block future taps. */
  var suppressedLink = null;
  var suppressTimer = null;

  function markSuppressed(link) {
    suppressedLink = link;
    if (suppressTimer) clearTimeout(suppressTimer);
    suppressTimer = setTimeout(function () {
      suppressedLink = null;
    }, 500);
  }

  /* ---------- whole-image drag & swipe (touch) ---------- */
  document.addEventListener('touchstart', function (e) {
    lastTouchTime = Date.now();
    if (e.target.closest(DRAG_EXCLUDE_SELECTOR)) return;
    var link = e.target.closest('.hdt-card-slider__draggable');
    if (!link) return;
    var track = getTrack(link);
    if (!track) return;
    dragStart = { link: link, track: track, startX: e.touches[0].clientX, moved: false };
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!dragStart) return;
    var diff = e.touches[0].clientX - dragStart.startX;
    if (Math.abs(diff) > DRAG_THRESHOLD) dragStart.moved = true;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (!dragStart) return;
    var endX = e.changedTouches[0].clientX;
    var diff = endX - dragStart.startX;
    var current = parseInt(dragStart.track.dataset.activeIndex || 0, 10);
    if (Math.abs(diff) > 30) {
      setActiveSlide(dragStart.track, diff < 0 ? current + 1 : current - 1);
      dragStart.moved = true;
    }
    if (dragStart.moved) markSuppressed(dragStart.link);
    dragStart = null;
  });

  /* ---------- whole-image drag & swipe (mouse) ---------- */
  document.addEventListener('mousedown', function (e) {
    if (Date.now() - lastTouchTime < GHOST_EVENT_WINDOW) return; /* ignore synthetic mouse event after touch */
    if (e.target.closest(DRAG_EXCLUDE_SELECTOR)) return;
    var link = e.target.closest('.hdt-card-slider__draggable');
    if (!link) return;
    var track = getTrack(link);
    if (!track) return;
    isDragging = true;
    link.classList.add('is-dragging');
    dragStart = { link: link, track: track, startX: e.clientX, moved: false };
    e.preventDefault();
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging || !dragStart) return;
    var diff = e.clientX - dragStart.startX;
    if (Math.abs(diff) > DRAG_THRESHOLD) dragStart.moved = true;
  });

  document.addEventListener('mouseup', function (e) {
    if (!isDragging || !dragStart) return;
    isDragging = false;
    dragStart.link.classList.remove('is-dragging');

    var diff = e.clientX - dragStart.startX;
    var current = parseInt(dragStart.track.dataset.activeIndex || 0, 10);
    if (Math.abs(diff) > 15) {
      setActiveSlide(dragStart.track, diff < 0 ? current + 1 : current - 1);
      dragStart.moved = true;
    }
    if (dragStart.moved) markSuppressed(dragStart.link);
    dragStart = null;
  });

  document.addEventListener('mouseleave', function () {
    if (isDragging && dragStart) dragStart.link.classList.remove('is-dragging');
    isDragging = false;
    dragStart = null;
  });

  /* Cancels navigation only for the one click that immediately follows
     a real drag; a plain tap with no movement always navigates. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.hdt-card-slider__draggable');
    if (link && link === suppressedLink) {
      e.preventDefault();
      e.stopPropagation();
      suppressedLink = null;
      if (suppressTimer) clearTimeout(suppressTimer);
    }
  }, true);

  /* ---------- nav strip: click anywhere in the strip jumps to the
     nearest segment (e.g. clicking near dot 3 shows image 3), no
     dead zones, no link navigation ---------- */
  function handleNavInteraction(e, nav) {
    e.preventDefault();
    e.stopPropagation();
    var track = getTrack(nav);
    if (!track) return;
    var segs = nav.querySelectorAll('.hdt-card-slider__seg');
    if (!segs.length) return;
    var rect = nav.getBoundingClientRect();
    var clientX = (e.clientX !== undefined) ? e.clientX
      : (e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : rect.left);
    var x = clientX - rect.left;
    var idx = Math.floor((x / rect.width) * segs.length);
    idx = Math.max(0, Math.min(segs.length - 1, idx));
    setActiveSlide(track, idx);
  }

  document.addEventListener('mousedown', function (e) {
    var nav = e.target.closest('.hdt-card-slider__nav');
    if (nav) { e.preventDefault(); e.stopPropagation(); }
  });
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.hdt-card-slider__nav');
    if (nav) handleNavInteraction(e, nav);
  });
  document.addEventListener('touchend', function (e) {
    var nav = e.target.closest('.hdt-card-slider__nav');
    if (nav) handleNavInteraction(e, nav);
  });

  /* ---------- prev/next arrow navigation ---------- */
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.hdt-card-slider__arrow');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var track = getTrack(arrow);
    if (!track) return;
    var current = parseInt(track.dataset.activeIndex || 0, 10);
    setActiveSlide(track, current + parseInt(arrow.dataset.dir, 10));
  });

  /* ---------- clickable size -> add to cart (unchanged) ---------- */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.hdt-size-list--clickable .hdt-swatch-item');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    if (swatch.dataset.available === 'false' || swatch.classList.contains('is-loading')) return;
    var variantId = swatch.dataset.variantId;
    if (!variantId) return;

    swatch.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('Add to cart failed', err);
        alert((err && err.description) || 'Could not add this item to your cart.');
      })
      .finally(function () {
        swatch.classList.remove('is-loading');
      });
  });

  function refreshCartDrawer() {
    var drawerEl = document.querySelector('hdt-cart-drawer[section-id]');
    if (!drawerEl) return Promise.resolve();
    var sectionId = drawerEl.getAttribute('section-id');

    return fetch('/?sections=' + encodeURIComponent(sectionId))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('hdt-cart-drawer');
        if (newDrawer && drawerEl.parentNode) {
          drawerEl.replaceWith(newDrawer);
        }
      })
      .catch(function (err) {
        console.error('Cart drawer refresh failed', err);
      });
  }

  function openCartDrawer() {
    var trigger = document.querySelector('[aria-controls="CartDrawer"]');
    if (trigger) {
      trigger.click();
      return;
    }
    var dialog = document.querySelector('#CartDrawer');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      window.location.href = '/cart';
    }
  }
})();